module.exports = __webpack_public_path__ + "img/butterfly-blue.64734c69.svg";